import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mx-5 mb-5"
}
const _hoisted_2 = { class: "pt-5 pb-3" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "text-center" }, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "bi bi-activity",
    style: {"font-size":"60px"}
  })
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "fs-1 fw-bold" }, "Alba Hub Monitor", -1)
const _hoisted_5 = {
  key: 0,
  class: "d-flex justify-content-between mt-2 fs-6 py-5 px-5 br-5"
}
const _hoisted_6 = { class: "text-center" }
const _hoisted_7 = { class: "mt-1" }
const _hoisted_8 = { class: "badge friBack1 fs-6 px-5 py-4" }
const _hoisted_9 = { class: "text-center" }
const _hoisted_10 = { class: "mt-1" }
const _hoisted_11 = { class: "badge friBack4 fs-6 px-5 py-4 text-dark" }
const _hoisted_12 = { class: "text-center" }
const _hoisted_13 = { class: "mt-1" }
const _hoisted_14 = { class: "badge friBack7 fs-6 px-5 py-4" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "text-left" }
const _hoisted_17 = ["src"]
const _hoisted_18 = { class: "text-left ms-3" }
const _hoisted_19 = {
  key: 0,
  class: "float-end fw-bold"
}
const _hoisted_20 = {
  key: 0,
  class: "pe-2"
}
const _hoisted_21 = {
  key: 1,
  class: "pe-2"
}
const _hoisted_22 = { key: 2 }
const _hoisted_23 = { class: "text-left text-xs3" }
const _hoisted_24 = {
  key: 0,
  class: "fs-6"
}
const _hoisted_25 = { key: 1 }
const _hoisted_26 = {
  key: 2,
  class: "friColor1 fw-bold"
}
const _hoisted_27 = {
  key: 3,
  class: "friColor2 fw-bold"
}
const _hoisted_28 = { key: 4 }
const _hoisted_29 = {
  key: 1,
  class: "mt-2",
  style: {"padding":"50px 0 0 0"}
}
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", {
  class: "text-center",
  style: {"padding":"150px 0 0 0"}
}, [
  /*#__PURE__*/_createElementVNode("i", {
    class: "bi bi-stop-circle-fill",
    style: {"font-size":"80px"}
  })
], -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold fs-3" }, "Monitor inactivo", -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "mt-2" }, "No se están registrando eventos", -1)
const _hoisted_33 = { key: 1 }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", {
  class: "text-center w-100",
  style: {"margin":"150px 0"}
}, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("i", {
      class: "bi bi-activity",
      style: {"font-size":"80px"}
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "fw-bold fs-3" }, "Jobs monitor"),
  /*#__PURE__*/_createElementVNode("div", { class: "mt-2" }, "Espere por favor ..."),
  /*#__PURE__*/_createElementVNode("div", {
    class: "spinner-border friColor1 mt-5",
    role: "status"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Cargando ...")
  ])
], -1)
const _hoisted_35 = [
  _hoisted_34
]
const _hoisted_36 = { class: "px-5 py-4 fs-6" }
const _hoisted_37 = { class: "fw-bold fs-1 mb-1" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("i", {
  class: "bi bi-x-circle",
  style: {"font-size":"30px"}
}, null, -1)
const _hoisted_39 = [
  _hoisted_38
]
const _hoisted_40 = {
  key: 0,
  class: "fs-3 mb-3"
}
const _hoisted_41 = {
  key: 1,
  class: "fs-3 mb-3"
}
const _hoisted_42 = { class: "float-end" }
const _hoisted_43 = {
  key: 0,
  class: "float-end fw-bold"
}
const _hoisted_44 = {
  key: 0,
  class: "pe-2"
}
const _hoisted_45 = {
  key: 1,
  class: "pe-2"
}
const _hoisted_46 = { key: 2 }
const _hoisted_47 = { class: "float-end" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("div", { class: "mt-5 mb-3 fs-6 fw-bold" }, "Dispositivo", -1)
const _hoisted_49 = { class: "float-end" }
const _hoisted_50 = { class: "float-end" }
const _hoisted_51 = { class: "float-end" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("div", { class: "mt-5 mb-3 fs-6 fw-bold" }, "Alarma", -1)
const _hoisted_53 = { class: "float-end" }
const _hoisted_54 = { class: "float-end fw-bold" }
const _hoisted_55 = { class: "float-end fw-bold friColor3" }
const _hoisted_56 = { key: 0 }
const _hoisted_57 = {
  key: 0,
  class: "float-end fw-bold"
}
const _hoisted_58 = { key: 0 }
const _hoisted_59 = {
  key: 0,
  class: "float-end fw-bold"
}
const _hoisted_60 = { class: "float-end" }
const _hoisted_61 = { class: "float-end" }
const _hoisted_62 = /*#__PURE__*/_createElementVNode("div", { class: "mt-5 mb-3 fs-6 fw-bold" }, "Notificaciones", -1)
const _hoisted_63 = { key: 4 }
const _hoisted_64 = { class: "float-end" }
const _hoisted_65 = { key: 0 }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-check-lg" }, null, -1)
const _hoisted_67 = [
  _hoisted_66
]
const _hoisted_68 = { key: 1 }
const _hoisted_69 = { class: "float-end" }
const _hoisted_70 = { key: 0 }
const _hoisted_71 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-check-lg" }, null, -1)
const _hoisted_72 = [
  _hoisted_71
]
const _hoisted_73 = { key: 1 }
const _hoisted_74 = { class: "float-end" }
const _hoisted_75 = { key: 0 }
const _hoisted_76 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-check-lg" }, null, -1)
const _hoisted_77 = [
  _hoisted_76
]
const _hoisted_78 = { key: 1 }
const _hoisted_79 = { class: "float-end" }
const _hoisted_80 = { key: 0 }
const _hoisted_81 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-check-lg" }, null, -1)
const _hoisted_82 = [
  _hoisted_81
]
const _hoisted_83 = { key: 1 }
const _hoisted_84 = /*#__PURE__*/_createElementVNode("div", { class: "mt-5 mb-3 fs-6 fw-bold" }, "Usuarios", -1)
const _hoisted_85 = { key: 5 }
const _hoisted_86 = { class: "float-end" }
const _hoisted_87 = /*#__PURE__*/_createElementVNode("div", { class: "mt-3 fs-6 fw-bold" }, "Acciones", -1)
const _hoisted_88 = {
  class: "mt-2 text-center mb-5",
  style: {"padding":"10px 0"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_modal = _resolveComponent("ion-modal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      class: "account-box is-form is-footerless",
      style: _normalizeStyle(_ctx.isMobile ? 'border-bottom: none !important;' : '')
    }, [
      (!_ctx.layout.loading && _ctx.layout.jobs && _ctx.layout.jobs?.logs)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            (_ctx.layout.jobs?.logs?.date)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", _hoisted_2, [
                    _hoisted_3,
                    _hoisted_4,
                    _createTextVNode(" " + _toDisplayString(_ctx.layout.jobs?.logs.date) + " ", 1),
                    (_ctx.layout.jobs?.logs?.processed_jobs)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                          _createElementVNode("div", _hoisted_6, [
                            _createTextVNode("Total "),
                            _createElementVNode("div", _hoisted_7, [
                              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.layout.jobs?.logs?.processed_jobs?.total), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_9, [
                            _createTextVNode("Pre-alarma "),
                            _createElementVNode("div", _hoisted_10, [
                              _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.layout.jobs?.logs?.processed_jobs?.warning), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_12, [
                            _createTextVNode("Alarma "),
                            _createElementVNode("div", _hoisted_13, [
                              _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.layout.jobs?.logs?.processed_jobs?.alarm), 1)
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  (_ctx.layout.jobs?.logs.jobs && _ctx.layout.jobs?.logs.jobs.length > 0)
                    ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.layout.jobs?.logs.jobs, (job, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: index,
                          class: _normalizeClass(["mb-3 p-5 br-8 cursor-pointer", !job.isAlarm ? 'friBorder3 friBack4' : 'friBorder4']),
                          onClick: ($event: any) => {_ctx.layout.jobEdit = job; _ctx.layout.jobBox = true}
                        }, [
                          _createElementVNode("div", _hoisted_16, [
                            _createVNode(_component_ion_grid, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_row, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_ion_col, {
                                      size: "2",
                                      class: "p-0 m-0 text-center"
                                    }, {
                                      default: _withCtx(() => [
                                        (_ctx.layout.apps && _ctx.layout.apps?.apps && Object.keys(_ctx.layout.apps?.apps).length && job.device && job.device.application_id && _ctx.layout.apps.apps[job.device.application_id])
                                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                              (_ctx.layout.apps.apps[job.device.application_id].logo)
                                                ? (_openBlock(), _createElementBlock("img", {
                                                    key: 0,
                                                    src: _ctx.layout.apps.apps[job.device.application_id].logo,
                                                    style: {"width":"100px"},
                                                    class: "me-2 br-8"
                                                  }, null, 8, _hoisted_17))
                                                : _createCommentVNode("", true)
                                            ], 64))
                                          : _createCommentVNode("", true)
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_ion_col, {
                                      size: "10",
                                      class: "p-0 m-0"
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_18, [
                                          _createElementVNode("div", null, [
                                            _createTextVNode(_toDisplayString(job.alarm.code) + " ", 1),
                                            (job.duration)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_19, [
                                                  (job.duration.days)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(job.duration.days) + "d", 1))
                                                    : _createCommentVNode("", true),
                                                  (job.duration.hours)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_21, _toDisplayString(job.duration.hours) + "h", 1))
                                                    : _createCommentVNode("", true),
                                                  (job.duration.minutes)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(job.duration.minutes) + "m", 1))
                                                    : _createCommentVNode("", true)
                                                ]))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _createElementVNode("div", {
                                            class: _normalizeClass(["fw-bold", _ctx.isMobile ? 'text-xs3' : 'fs-5'])
                                          }, _toDisplayString(job.alarm.name), 3),
                                          _createElementVNode("div", _hoisted_23, [
                                            (_ctx.layout.apps && _ctx.layout.apps?.apps && Object.keys(_ctx.layout.apps?.apps).length && job.device && job.device.application_id && _ctx.layout.apps.apps[job.device.application_id])
                                              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                                  (_ctx.layout.apps.apps[job.device.application_id]?.client)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_24, _toDisplayString(_ctx.layout.apps.apps[job.device.application_id]?.client['first']) + " " + _toDisplayString(_ctx.layout.apps.apps[job.device.application_id]?.client['last']), 1))
                                                    : _createCommentVNode("", true)
                                                ], 64))
                                              : _createCommentVNode("", true),
                                            _createElementVNode("div", null, "Iniciado: " + _toDisplayString(job.date), 1),
                                            _createElementVNode("div", null, "Dispositivo: " + _toDisplayString(job.device.type) + " (" + _toDisplayString(job.device.device_id) + ")", 1),
                                            (job.status == 'pending')
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_25, "Pre-Alarma"))
                                              : (job.status == 'notified')
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_26, "Notificada"))
                                                : (job.status == 'warning')
                                                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, "Aviso"))
                                                  : (_openBlock(), _createElementBlock("div", _hoisted_28, _toDisplayString(job.status), 1))
                                          ])
                                        ])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024)
                          ])
                        ], 10, _hoisted_15))
                      }), 128))
                    : (_openBlock(), _createElementBlock("div", _hoisted_29, "No dispone de eventos en curso"))
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_30,
                  _hoisted_31,
                  _hoisted_32
                ], 64))
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_33, _hoisted_35))
    ], 4),
    _createVNode(_component_ion_modal, {
      "is-open": _ctx.layout.jobBox,
      "backdrop-dismiss": false
    }, {
      default: _withCtx(() => [
        (_ctx.layout.jobEdit)
          ? (_openBlock(), _createBlock(_component_ion_content, {
              key: 0,
              class: "m-5"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("div", _hoisted_37, [
                    _createTextVNode(_toDisplayString(_ctx.layout.jobEdit.alarm.name) + " ", 1),
                    _createElementVNode("span", {
                      class: "float-end",
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.layout.jobBox = false))
                    }, _hoisted_39)
                  ]),
                  (_ctx.layout.jobEdit.isAlarm)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_40, "Alarma"))
                    : (_openBlock(), _createElementBlock("div", _hoisted_41, "Pre-alarma")),
                  _createElementVNode("div", null, [
                    _createTextVNode("Iniciado: "),
                    _createElementVNode("span", _hoisted_42, _toDisplayString(_ctx.layout.jobEdit.date), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _createTextVNode(" Duración: "),
                    (_ctx.layout.jobEdit.duration)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_43, [
                          (_ctx.layout.jobEdit.duration.days)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_44, _toDisplayString(_ctx.layout.jobEdit.duration.days) + "d", 1))
                            : _createCommentVNode("", true),
                          (_ctx.layout.jobEdit.duration.hours)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_45, _toDisplayString(_ctx.layout.jobEdit.duration.hours) + "h", 1))
                            : _createCommentVNode("", true),
                          (_ctx.layout.jobEdit.duration.minutes)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_46, _toDisplayString(_ctx.layout.jobEdit.duration.minutes) + "m", 1))
                            : _createCommentVNode("", true)
                        ]))
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("div", null, [
                    _createTextVNode("Estado: "),
                    _createElementVNode("span", _hoisted_47, _toDisplayString(_ctx.layout.jobEdit.status), 1)
                  ]),
                  _hoisted_48,
                  _createElementVNode("div", null, [
                    _createTextVNode("Alba Hub: "),
                    _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.layout.jobEdit.device.application_id), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _createTextVNode("Identificador: "),
                    _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.layout.jobEdit.device.device_id), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _createTextVNode("Tipo: "),
                    _createElementVNode("span", _hoisted_51, _toDisplayString(_ctx.layout.jobEdit.device.type), 1)
                  ]),
                  _hoisted_52,
                  _createElementVNode("div", null, [
                    _createTextVNode("Código de alarma: "),
                    _createElementVNode("span", _hoisted_53, _toDisplayString(_ctx.layout.jobEdit.alarm.code), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _createTextVNode("Límite: "),
                    _createElementVNode("span", _hoisted_54, _toDisplayString(_ctx.layout.jobEdit.alarm.alarmValue) + " " + _toDisplayString(_ctx.layout.jobEdit.device.unit), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _createTextVNode("Detectado: "),
                    _createElementVNode("span", _hoisted_55, _toDisplayString(_ctx.layout.jobEdit.alarm.currentValue) + " " + _toDisplayString(_ctx.layout.jobEdit.device.unit), 1)
                  ]),
                  (_ctx.layout.jobEdit.alarm.paramSensor && _ctx.layout.jobEdit.alarm.paramSensor == 'TempC_SHT')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                        (_ctx.layout.device)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                              _createTextVNode("Actualizado (" + _toDisplayString(_ctx.layout.helper.getDateFormatFb(_ctx.layout.device.device.status.date)) + "): ", 1),
                              (_ctx.layout.device.device.status.msg.TempC_SHT)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_57, _toDisplayString(parseFloat(_ctx.layout.device.device.status.msg.TempC_SHT).toFixed(1)) + " " + _toDisplayString(_ctx.layout.jobEdit.device.unit), 1))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true),
                  (_ctx.layout.jobEdit.alarm.paramSensor && _ctx.layout.jobEdit.alarm.paramSensor == 'Hum_SHT')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                        (_ctx.layout.device)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                              _createTextVNode("Actualizado (" + _toDisplayString(_ctx.layout.helper.getDateFormatFb(_ctx.layout.device.device.status.date)) + "): ", 1),
                              (_ctx.layout.device.device.status.msg. Hum_SHT)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_59, _toDisplayString(parseFloat(_ctx.layout.device.device.status.msg.Hum_SHT).toFixed(1)) + " " + _toDisplayString(_ctx.layout.jobEdit.device.unit), 1))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ], 64))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.viewDevice())),
                    class: "text-center friBack1 px-5 py-2 br-5 text-white my-5 cursor-pointer"
                  }, "Actualizar estado"),
                  _createElementVNode("div", null, [
                    _createTextVNode("Aviso: "),
                    _createElementVNode("span", _hoisted_60, _toDisplayString(_ctx.layout.jobEdit.alarm.warning) + " min", 1)
                  ]),
                  _createElementVNode("div", null, [
                    _createTextVNode("Notificación: "),
                    _createElementVNode("span", _hoisted_61, _toDisplayString(_ctx.layout.jobEdit.alarm.notify) + " min", 1)
                  ]),
                  _hoisted_62,
                  (_ctx.layout.jobEdit.notify)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_63, [
                        _createElementVNode("div", null, [
                          _createTextVNode("App "),
                          _createElementVNode("span", _hoisted_64, [
                            (_ctx.layout.jobEdit.notify.app)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_65, _hoisted_67))
                              : (_openBlock(), _createElementBlock("span", _hoisted_68, "No"))
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _createTextVNode("Whatsapp "),
                          _createElementVNode("span", _hoisted_69, [
                            (_ctx.layout.jobEdit.notify.whatsapp)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_70, _hoisted_72))
                              : (_openBlock(), _createElementBlock("span", _hoisted_73, "No"))
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _createTextVNode("Email "),
                          _createElementVNode("span", _hoisted_74, [
                            (_ctx.layout.jobEdit.notify.email)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_75, _hoisted_77))
                              : (_openBlock(), _createElementBlock("span", _hoisted_78, "No"))
                          ])
                        ]),
                        _createElementVNode("div", null, [
                          _createTextVNode("SMS "),
                          _createElementVNode("span", _hoisted_79, [
                            (_ctx.layout.jobEdit.notify.sms)
                              ? (_openBlock(), _createElementBlock("span", _hoisted_80, _hoisted_82))
                              : (_openBlock(), _createElementBlock("span", _hoisted_83, "No"))
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  _hoisted_84,
                  (_ctx.layout.jobEdit?.users)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_85, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.layout.jobEdit.users, (user, index) => {
                          return (_openBlock(), _createElementBlock("div", { key: index }, [
                            _createElementVNode("div", null, [
                              _createTextVNode(_toDisplayString(user.name) + " ", 1),
                              _createElementVNode("span", _hoisted_86, _toDisplayString(user.email), 1)
                            ])
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  _hoisted_87,
                  _createElementVNode("div", _hoisted_88, [
                    _createElementVNode("button", {
                      class: "button button v-button py-05 friBack4",
                      type: "button",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.layout.jobBox = false))
                    }, "Cerrar")
                  ])
                ]),
                _createElementVNode("pre", null, _toDisplayString(_ctx.layout.jobEdit), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["is-open"])
  ]))
}